import AppFooter from './modules/views/AppFooter';
import ProductHero from './modules/views/ProductHero';
import ProductDemo from './modules/views/ProductGovSkyDemo';
import ProductFeatures from './modules/views/ProductFeatures';
import AppHeaderBar from './modules/views/AppAppBar';
import withRoot from './modules/withRoot';

function Index() {
  return (
    <>
      <AppHeaderBar />
      <ProductHero />
      <ProductFeatures />
      <ProductDemo />
      <AppFooter />
    </>
  );
}

export default withRoot(Index);
